module.exports = __webpack_public_path__ + "assets/photos/memories/frame-6-mobile--5e881cfe17334f0964076ac059fa3631.jpg";